<template>
  <div style="padding:20px;">
    <el-row :gutter="24">
      <el-row style="margin-bottom: 10px;">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
        奖品：
        <el-input class="search-el" v-model="query.course_words" size="small"  placeholder="奖品名称/福袋ID" clearable></el-input>
        用户：
        <el-input class="search-el" v-model="query.user_words" size="small"  placeholder="用户名/手机号/用户ID" clearable></el-input>
        类型：
        <el-select class="search-el" clearable size="small" v-model="query.type" placeholder="选择类型">
          <el-option label="全部" value=""></el-option>
          <el-option label="体验营" value="1"></el-option>
          <el-option label="实物奖品" value="2"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="searchData()" >搜索</el-button>
        <el-button type="primary" size="small" @click="exportData()">导出名单</el-button>
        <el-button type="primary" size="small" :disabled="listRefresh" @click="refresh()" >刷新</el-button>
      </el-row>
      <el-table :data="listData" style="width: 100%" border v-loading="listLoading">
        <el-table-column
            label="用户ID"
            align="center"
            min-width="20%"
            width="90"
        >
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toInfo(row.user_id)">
              <div>{{ row.user_id }}</div>
            </el-button>
          </template>
        </el-table-column>
<!--        <el-table-column prop="user_id" label="用户ID" align="center" width="90"></el-table-column>-->
        <el-table-column prop="nickname" align="center" label="用户名" width="200"></el-table-column>
        <el-table-column prop="blessing_bag_id" align="center" label="福袋ID" width="90"></el-table-column>
        <el-table-column prop="type_txt" label="奖品类型" align="center" width="100"></el-table-column>
        <el-table-column prop="title" label="奖品名称" align="center" width="200"></el-table-column>
        <el-table-column label="收货地址" align="left" min-width="" width="300">
          <template slot-scope="{ row }">
            {{ row.address }}<br />
            {{ row.address_phone }}
          </template>
        </el-table-column>
        <el-table-column prop="mobile_phone" label="手机号" align="center" width="200"></el-table-column>
        <el-table-column prop="order_no" label="订单编号" align="center" width="200"></el-table-column>
        <el-table-column prop="status_txt" label="状态" align="center" width="100"></el-table-column>
<!--        <el-table-column prop="id" label="操作"></el-table-column>-->
      </el-table>

      <div style="margin-top:10px">
        <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit" layout="total, prev, pager, next, jumper" :total="listTotal">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getWinnerList } from '@/api/live';
const axios = require('axios');
export default {
  data: function () {
    return {
      course_id: this.$route.query.course_id,
      period_id: this.$route.query.period_id,
      listData: [],
      listLoading: false,
      listRefresh: false,
      listTotal: 0,
      wechatDisabled:true,
      query: {
        course_id: this.$route.query.course_id,
        period_id: this.$route.query.period_id,
        limit: 20,
        page: 1,
        course_words: "",
        user_words: "",
        type: "",
        export: 0,
      },
    }
  },
  created: function() {
    this.getList();
  },
  methods: {
    getList(){
      this.listLoading = true;
      getWinnerList(this.query).then(response => {
        this.listData = response.data.list
        this.listTotal = response.data.total
        this.listLoading = false;
      });
    },
    searchData(){
      this.listLoading = true;
      getWinnerList(this.query).then(response => {
        this.listData = response.data.list
        this.listLoading = false;
      });
    },
    refresh() {
      this.query.page = 1
      this.query.course_words = ''
      this.query.user_words = ''
      this.query.type = ''
      this.getList()
    },
    exportData(){
      this.listLoading = true;
      this.listRefresh = true
      this.query.export = 1;//导出为1
      /*getWinnerList(this.query).then(response => {
        this.listData = response.data.list
        this.listLoading = false;
      });*/
      axios({
        method: "post",
        url: "/backend/live/blessingBag/getWinnerList",
        data: this.query,
        responseType: "blob",
      }).then((res) => {
        //console.log(res)
        const link = document.createElement("a");
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "福袋中奖用户数据.xls");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.query.export = 0;
        this.listLoading = false;
        this.listRefresh = false;
      }).catch((error) => {
        this.$Notice.error({
          title: "错误",
          desc: "网络连接错误",
        });
        console.log(error);
      });
    },
    toInfo(id = 0) {
      this.$router.push({
        path: "/user/info",
        query: {
          id: id,
          admin_id: 0,
          admin_name: this.$route.query.admin_name,
        }
      });
    },
  },
}
</script>

<style>
</style>